import { render, staticRenderFns } from "./incl-pimProducts.vue?vue&type=template&id=223d5483&scoped=true"
import script from "./incl-pimProducts.vue?vue&type=script&lang=js"
export * from "./incl-pimProducts.vue?vue&type=script&lang=js"
import style0 from "./incl-pimProducts.vue?vue&type=style&index=0&id=223d5483&prod&lang=scss&scoped=true"
import style1 from "./incl-pimProducts.vue?vue&type=style&index=1&id=223d5483&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223d5483",
  null
  
)

export default component.exports